import MessageForm from '@/modules/live-messages/form/MessageForm';
import DataTableRow from '@/modules/live-messages/components/DataTableRow';
import MessageEditorDialogButtons from '@/modules/live-messages/components/MessageEditorDialogButtons';

const dataTableHeader = [
  {
    text: 'Fecha de publicación', value: 'publicationDate',
  },
  {
    text: 'Texto', value: 'body', width: '50%', sortable: false,
  },
  {
    text: 'Estado', value: 'published', sortable: false,
  },
  {
    text: 'Acciones', value: 'name', sortable: false,
  },
];

const dataTableConfig = {
  rowComponent: DataTableRow,
  messageEditorDialogButtonsComponent: MessageEditorDialogButtons,
};

/**
 * Message form based on the live type being edited.
 * Example: <pre>
    {
      live: LiveMessageForm,
      footballLive: FootbalLiveMessagForm,
    }
  </pre>
 * @type {{string: Object}}
 */
const MessageFormByContentType = {
  live: MessageForm,
  default: MessageForm,
};


export default {
  dataTableHeader,
  dataTableConfig,
  /** @deprecated in favor of MessageFormByContentType.default */
  MessageForm,
  MessageFormByContentType,
};
